import React, { useState } from "react";
import Calendar from "react-calendar";
import { Card, Box } from "@mui/material";
import "./BlackoutStyles.css";

const BlackoutCalendar = ({ onDateChange, blackoutDates = [] }) => {
  console.log(blackoutDates);
  const [value, setValue] = useState(new Date());

  const onChange = (nextValue) => {
    setValue(nextValue);
    onDateChange(nextValue);
  };

  const isBlackoutDate = ({ date }) => {
    console.log(`Incoming Date from Calendar: ${date}`);

    const formattedDateForIncoming = `${date.getFullYear()}-${String(
      date.getMonth() + 1
    ).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;

    console.log("Checking:", formattedDateForIncoming);
    blackoutDates.forEach((bDate) => console.log("Against:", bDate.date));
    return blackoutDates.some(
      (blackoutDate) => blackoutDate.date === formattedDateForIncoming
    );
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 2,
      }}
    >
      <Card elevation={3}>
        <Box sx={{ p: 3 }}>
          <Calendar
            onChange={onChange}
            value={value}
            minDate={new Date()} // Disable past dates
            tileDisabled={isBlackoutDate} // Disable blackout dates
          />
        </Box>
      </Card>
    </Box>
  );
};

export default BlackoutCalendar;
